import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling-light";
import { orchestrator } from "satcheljs";
import { onPreCoprincipalAccountRemoved, type CoprincipalAccountSource, } from "owa-account-source-list-store";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { trace } from "owa-trace";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaM365AcquisitionsDatabase" */ "./lazyIndex"), { name: "OwaM365AcquisitionsDatabase" });

export const lazyUpdateDatabaseCachedAcquisitions: LazyAction<typeof lazyIndex.updateDatabaseCachedAcquisitions, typeof lazyModule> = new LazyAction(lazyModule, m => m.updateDatabaseCachedAcquisitions);

export const lazyWriteToAcquisitionsCacheFromIndexedDb: LazyAction<typeof lazyIndex.writeToAcquisitionsCacheFromIndexedDb, typeof lazyModule> = new LazyAction(lazyModule, m => m.writeToAcquisitionsCacheFromIndexedDb);

export const lazyWriteCacheMetadata: LazyAction<typeof lazyIndex.writeCacheMetadata, typeof lazyModule> = new LazyAction(lazyModule, m => m.writeCacheMetadata);

export const lazyReadCacheMetadata: LazyAction<typeof lazyIndex.readCacheMetadata, typeof lazyModule> = new LazyAction(lazyModule, m => m.readCacheMetadata);

export const lazyValidateCacheTtl: LazyAction<typeof lazyIndex.validateCacheTtl, typeof lazyModule> = new LazyAction(lazyModule, m => m.validateCacheTtl);

export const lazyInvalidateCache: LazyAction<typeof lazyIndex.invalidateCache, typeof lazyModule> = new LazyAction(lazyModule, m => m.invalidateCache);

export const lazyDetectPartialFailure: LazyAction<typeof lazyIndex.detectPartialFailure, typeof lazyModule> = new LazyAction(lazyModule, m => m.detectPartialFailure);

export const lazyReadCachedAcquisitions: LazyAction<typeof lazyIndex.readCachedAcquisitions, typeof lazyModule> = new LazyAction(lazyModule, m => m.readCachedAcquisitions);

const lazyDeleteDatabaseById: LazyAction<typeof lazyIndex.deleteDatabaseById, typeof lazyModule> = new LazyAction(lazyModule, m => m.deleteDatabaseById);

// Eager orchestrator with lazy execution: registerLazyOrchestrator (owa-bundling) can't
// be used because owa-bundling transitively imports react, breaking data-worker contexts.
// This is the owa-bundling-light equivalent — the orchestrator registers eagerly but the
// heavy database code (Dexie) only loads via importAndExecute when the action fires.
orchestrator(onPreCoprincipalAccountRemoved, actionMessage => {
    const removedAccount = actionMessage?.removedAccount as CoprincipalAccountSource;
    if (removedAccount &&
        removedAccount.persistenceId &&
        isAccountFeatureEnabled("addin-acquisitionsCacheReliability", removedAccount.mailboxInfo)) {
        void lazyDeleteDatabaseById.importAndExecute(removedAccount.persistenceId).catch(() => {
            trace.warn(`[onAccountRemovedOrchestrator] Failed to delete acquisitions database`, "addins");
        });
    }
});
